/*export default function PageLoading() {
  return <div>Loading...</div>;
}*/

import { useEffect } from "react";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default function PageLoading() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    }
  });

  return (
    <div className="grid min-h-screen animate-pulse place-content-center text-6xl text-white">
      Loading...
    </div>
  );
}
